// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__lgrZW","save":"styles_save__2ULIl"};